export const checkForZeroOrNull = (value: string | undefined | number, nullValue: string) => {
  if (!value) return nullValue;
  if (typeof value === 'number' && value <= 0) return nullValue;
  if (typeof value === 'string' && parseFloat(value) <= 0) return nullValue;
  return value;
};
